const reviewsSlider = document?.querySelectorAll('.reviews-slider');
reviewsSlider?.forEach((item) => {
  // slider with text rotator

  const sliderWithTextRotator = item?.querySelector(
    '.keen-slider.with-text-rotator',
  );
  let slider = null;

  if (sliderWithTextRotator) {
    slider = new KeenSlider(sliderWithTextRotator, {});
    const nextBtn = item?.querySelector(
      ' .slider-navigation.with-text-rotator .next',
    );
    const prevBtn = document?.querySelector(
      ' .slider-navigation.with-text-rotator .prev',
    );
    const progressBar = document?.querySelector(
      ' .slider-navigation.with-text-rotator .progress-bar',
    );

    nextBtn?.addEventListener('click', function () {
      slider?.next();
    });
    prevBtn?.addEventListener('click', function () {
      slider?.prev();
    });

    slider.on('slideChanged', () => {
      const slides = slider?.track?.details?.maxIdx;
      const index = slider?.track?.details?.rel;
      const percentage = (index / slides) * 100;
      progressBar.style.width = `${percentage}%`;
    });
  }

  // default review slider

  const defaultSliderEl = item?.querySelector('.keen-slider.default-reviews');

  if (defaultSliderEl) {
    const defaultSlider = new KeenSlider(defaultSliderEl, {
      breakpoints: {
        '(min-width: 540px)': {
          slides: { perView: 2, spacing: 30 },
        },
        '(min-width: 900px)': {
          slides: { perView: 3, spacing: 30 },
        },
        '(min-width: 1096px)': {
          slides: { perView: 3, spacing: 50 },
        },
      },

      slides: { perView: 1, spacing: 50 },
    });
    const prevBtn = item?.querySelector('.slider-arrows .arrow-left');
    const nextBtn = item?.querySelector('.slider-arrows .arrow-right');
    nextBtn?.addEventListener('click', function () {
      defaultSlider?.next();
    });
    prevBtn?.addEventListener('click', function () {
      defaultSlider?.prev();
    });
  }

  function handleResize() {
    if (slider?.container?.classList?.contains('with-text-rotator') && slider) {
      if (window?.innerWidth <= 640) {
        slider.update({
          slides: { perView: window.innerWidth / 290, spacing: 20 },
        });
      } else if (window?.innerWidth <= 1040) {
        slider.update({
          slides: { perView: window.innerWidth / 400, spacing: 20 },
        });
      } else if (window?.innerWidth <= 1200) {
        slider.update({
          slides: { perView: window.innerWidth / 400, spacing: 20 },
        });
      } else {
        slider.update({
          slides: { perView: window.innerWidth / 450, spacing: 20 },
        });
      }
    }
  }
  handleResize();
  window.addEventListener('resize', handleResize);
  window.addEventListener('load', handleResize);
});
